export const contentStyles = {
  contentContainerStackToken: {
    childrenGap: 16,
  },
  urlFieldStackToken: {
    childrenGap: 16,
  },
  pathFieldStackToken: {
    childrenGap: 6,
  },
  actionStackToken: {
    childrenGap: 16,
  },
  errorStackToken: {
    childrenGap: 6,
  },
};

export const textFieldStyles = (props) => {
  const { inputClassName } = props;
  const noInlineError = inputClassName === 'no-inline-error';

  return {
    charCountDescription: {
      root: {
        textAlign: 'right',
        fontWeight: 'normal',
        fontSize: 14,
      },
    },
    dynamicLinkContainer: {
      marginLeft: '5px',
    },
    dynamicLink: {
      root: {
        padding: '5px',
        selectors: {
          '&:focus': {
            boxShadow: 'none !important',
            outline: '1px solid rgb(96, 94, 92) !important',
          },
        },
      },
    },
    errorMessage: noInlineError ? { display: 'none' } : {},
  };
};

export const containerStyles = {
  container: {
    root: {
      width: '100%',
      minHeight: '100%',
      position: 'relative',
      selectors: {
        '& .rsa-left-copilot-column': {
          maxWidth: 600,
          '& .rsa-card-title': {
            fontSize: '18px',
            display: 'inline',
          },
        },
        '& .rsa-right-column': {
          '& .fixed': {
            position: 'sticky',
            top: 0,
          },
        },
        '& .rsa-left-column': {
          maxWidth: 592,
          minWidth: 460,
          width: '100%',
          '& .collapse-panel .img-ext-pane': {
            borderTop: 'none',
            borderBottom: 'none',
          },
          '& .collapse-panel .img-ext-pane-header': {
            display: 'none',
          },
          '& .collapse-panel .title-item': {
            width: 'auto',
          },
          '& .copilot-banner-container': {
            marginBottom: 8,
          },
        },

        '& .rsa-errors': {
          color: '#A80000',
          fontSize: 12,
        },

        '& .rsa-errors .error': {
          margin: 0,
        },
        '& .rsa-field-path1, & .rsa-field-path2': {
          width: '30%',
        },
      },
    },
  },
  input: {
    root: {
      padding: 16,
      overflow: 'hidden',
    },
  },
  preview: {
    root: {
      padding: '0 32px',
    },
  },
  contentContainer: {
    root: {
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
  urlPath: {
    root: {
      flexFlow: 'row wrap',
      wordBreak: 'break-all',
      '& .rsa-field-display-url': {
        paddingBottom: '8px',
      },
    },
  },
};

export const stickyAdPreviewStyles = {
  position: 'sticky',
  top: 50,
};
